import React, { memo } from "react";

import { Icon } from "@partials";

import { ListItemType } from "../types";

interface Props {
  item: ListItemType;
  iconsList: any;
  showDates: boolean;
}

const ResultItem: React.FC<Props> = ({ item, iconsList, showDates }) => {
  const { arrowRight } = iconsList;

  return (
    <div className="mt-8 sm:col-8">
      <a href={item.url} className="group block h-full rounded bg-light p-8 shadow-tab ">
        {showDates && <div className="text-xs text-grey-160">{item.date}</div>}
        <div className="max-w-full break-words text-lg group-hover:text-red-corporate group-hover:underline">
          {/* eslint-disable-next-line react/no-danger */}
          <span dangerouslySetInnerHTML={{ __html: item.title }} />
          <Icon
            name={arrowRight.name}
            viewBox={arrowRight.viewbox}
            alt={arrowRight.alt}
            svg={arrowRight.svg}
            className="inline h-6 w-6 fill-red-corporate"
          />
        </div>
      </a>
    </div>
  );
};

export default memo(ResultItem);
